import { render, staticRenderFns } from "./DataProductLink.vue?vue&type=template&id=4d62e799"
import script from "./DataProductLink.vue?vue&type=script&lang=js"
export * from "./DataProductLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports